/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Airport } from '../../models/airport';
import { BaseResponse } from '../../models/base-response';
import { DtoCreateAirport } from '../../models/dto-create-airport';

export interface CommonControllerUpdateAirport$Params {
  code: string;
      body: DtoCreateAirport
}

export function commonControllerUpdateAirport(http: HttpClient, rootUrl: string, params: CommonControllerUpdateAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerUpdateAirport.PATH, 'patch');
  if (params) {
    rb.path('code', params.code, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: Airport;
      }>;
    })
  );
}

commonControllerUpdateAirport.PATH = '/common/airports/{code}';
